import { createSlice } from '@reduxjs/toolkit';

const queueSlice = createSlice({
  name: 'queue',
  initialState: {
    queues: [],
    dataValid: false
  },
  reducers: {
    setQueues(state, action) {
        console.count("queueSlice: setQueues");
        if (!action || !action.payload || !action.payload.queues) {
          state.queues = [];    
        } else {
          state.queues = action.payload.queues;
        }      
    },
    invalidateData(state, action) {
        state.dataValid = false;
    }
  },
});

export const queueActions = queueSlice.actions;

export default queueSlice;